export const ROUTE_URL =[
    "/dashboard",
    "/parttimer-profile",
    "/payment",
    "/jobPostPayment",
    "/jobs",
    "/certifications",
    "/applied-list-certifications",
    "/userProfile",
    "/postjob",
    "/viewjob",
    "/viewCandidate",
    "viewCandidateShortTerm",
    "/billing",
    "/my-jobs",
    "/employeeview",
    "/rejection-subscription",
    "/viewuser",
    "/groups"
    
]

export const PUBLIC_URL =[
    "/login",
    "/signup",
    "/employeesignin",
    "/company-registration",
    "/company-registration-offer",
    "/account-verify", 
    "/account-verify-successful", 

]

export const ROLE ={
    EMPLOYER : 1,
    PARTTIMER : 2,
  }